import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { JustinoControlAccesoService } from '../../../services/justino-control-acceso.service';

@Component({
  selector: 'app-justino-anime',
  templateUrl: './justino-anime.component.html',
  styleUrl: './justino-anime.component.scss',
})
export class JustinoAnimeComponent {
  isChatOpen: boolean = false;
  justinoActive = false;
  showBubble: boolean = false;
  private routerSubscription!: Subscription;

  constructor(
    private router: Router
  ) { 
    // Suscribirse a los eventos de navegación para actualizar justinoActive
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        console.log('Navigating to:', event.url);
        if (event.url === '/justino/bot') {
          this.justinoActive = false;
          this.isChatOpen = true;
        } else {
          this.isChatOpen = false;
          this.justinoActive = true;
        }
      }
    });
  }

  redirectToPage() {
    this.justinoActive = false;
    this.showBubble = false;
    this.router.navigate(['/justino/bot']);
  }

  handleMouseOver() {
    const gifElement = document.getElementById('cornerGif') as HTMLImageElement;
    if (gifElement) {
      gifElement.src = 'assets/gif/Giff_Justino.gif?' + new Date().getTime();
    }
  }
}
